import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/shared/providers/settings.service';

@Component({
  selector: 'app-tweakerstyle',
  templateUrl: './tweakerstyle.component.html',
  styleUrls: ['./tweakerstyle.component.scss']
})
export class TweakerstyleComponent implements OnInit {

  constructor(
    public settingsService: SettingsService
  ) { }

  ngOnInit(): void {
  }

}
